/**
 * LOSS_REASONS — motivos de perda do CRM (fonte única).
 *
 * Compartilhado entre o CrmLoseReasonPopover (rodapé do painel / régua de follow-up)
 * e o ConfirmLossModal (perda assistida global, F5). Manter os slugs alinhados ao
 * backend (AccountSetting::DEFAULT_LOSS_REASONS) num único lugar evita divergência.
 *
 * Alinhado ao spec §6.3 (F4): relabel de sem_resposta; + frete_distancia, + prazo_longo;
 * timing e produto_nao_adequado SAEM da UI (slugs seguem válidos no backend p/ histórico).
 *
 * pt-BR locked (v1): rótulos hardcoded por decisão de escopo — sem i18n no v1.
 * TODO(fase2): buscar via API quando crm_account_settings.loss_reasons tiver override por conta.
 */
export const LOSS_REASONS = [
  { value: 'preco', label: 'Preço' },
  { value: 'concorrencia', label: 'Comprou concorrente' },
  { value: 'sem_resposta', label: 'Sumiu/sem resposta' },
  { value: 'frete_distancia', label: 'Frete/distância' },
  { value: 'prazo_longo', label: 'Prazo longo' },
  { value: 'nao_qualificado', label: 'Fora de perfil' },
  { value: 'outro', label: 'Outro' },
];
